import * as React from 'react';
const { connect } = require('react-redux');
import { InjectedRouter, PlainRoute } from 'react-router';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import { IShopProfile } from 'models/shop/shopprofile';
import { IModalAction } from 'models/modal';
import { getShop, putShop } from 'modules/shop/manageshop';
import { showModal, closeModal } from 'modules/modal';
import { ManageShopWrapper } from 'containers';
import { getConnectedShopGeneral } from 'containers/Shop/Common/ShopGeneral';
import { ICreateShopObject } from 'models/shop/createshop';
import { UserPreferences } from 'models/user/userpreferences';

interface IProps {
	params?: IParams;
	location?: any;
	router?: InjectedRouter;
	route?: PlainRoute;
	state: IStore;
	shop?: IShopProfile;

	busy?: boolean;
	/* functions props */
	getShop: (id: string) => Promise<any>;
	putShop: (shop: IShopProfile, shouldClearForm: boolean) => any;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	t?: (key: string) => string;
	userPreferences?: UserPreferences;
}

interface IParams {
	id?: string;
}

const ShopGeneral = getConnectedShopGeneral(c.FORM_NAME_MANAGE_SHOP);

const ManageShopGeneralForm: React.FC<IProps> = (props: IProps) => {
	// const { t, busy } = props;
	const { id } = (props?.params && props.params) || {};

	React.useEffect(() => {
		props.getShop(id);
	}, [id]);

	const saveShop = (fullData: ICreateShopObject<IShopProfile>) => {
		let shouldRefresh: boolean = true;

		if (props.shop.name != fullData.shop.name) {
			// remove all non-ASCII characters, special characters and spaces from shop name to generate the correct shop code
			const newCode = fullData.shop.name
				.replace(/[^\w\s]/gi, '')
				.replace(/[^\x00-\x7F]+/, '')
				.replace(/[`~¨!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '')
				.replace(/\s/g, '');
			fullData.shop.code = newCode;
			fullData.shop.metatagTitle = fullData.shop.name;
			fullData.shop.shippingName = fullData.shop.name;
		} else {
			shouldRefresh = false;
		}

		props.putShop(fullData.shop, shouldRefresh).then((error) => {
			if (!error && shouldRefresh) window.location.reload(); // TODO: find a better way to update the state of the shop (now it doesn't update it if we don't reload)
		});
	};

	const content = props.shop ? (
		<>
			<ShopGeneral {...props} redux="manageShop" onSubmit={saveShop} />
		</>
	) : null;

	return (
		<ManageShopWrapper route={props.route} id={id} shop={props.shop}>
			{content}
		</ManageShopWrapper>
	);
};

let ManageShopGeneral = connect(
	(state: IStore) => ({
		shop: state.manageShop.shop,
		busy: state.manageShop.isFetching,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		getShop: (id: string) => dispatch(getShop(id, false, false, true, true)),
		putShop: (form: IShopProfile, shouldClearForm: boolean) => dispatch(putShop(form, 'general', shouldClearForm)),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)(ManageShopGeneralForm);

ManageShopGeneral = translate(c.DEFAULT_TRANSLATION_NAMESPACE)(ManageShopGeneral);

export { ManageShopGeneral };
